<div #exportContent>
  <mat-card class="coverage-over-vew-widget-container">
    <div class="header">
      <div class="title">
        State Level Restoration Metrics
        @if (allYears()) {
          <span>({{ availableYears()[0] }} - {{ availableYears().at(-1) }})</span>
        }
      </div>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        @if (exporting()) {
          <vulcan-icon class="spin-icon" size="24px" icon="spinner-gap"></vulcan-icon>
        } @else {
          <vulcan-icon size="24px" icon="download"></vulcan-icon>
        }
      </button>
    </div>
    <mat-card-content>
      @if (metricRef.isLoading()) {
        <div>loading...</div>
      } @else if (metricRef.error()) {
        <div>There was an error loading state restoration data</div>
      } @else {
        @let metric = metricRef.value()![0];
        <section class="performance-card">
          <header class="card_title">
            Compared to all US states, DC, and Puerto Rico, <strong> {{ territory()?.name }} </strong> demonstrates
            mid-tier performance
            during extreme events:
          </header>

          <ul class="metrics">
            <li>
              <strong>{{ metric.impactLevelRank }}<sup>{{ metric.impactLevelRank |ordinalSuffix }}</sup></strong>
              in impact level, or the maximum number of customers impacted during extreme events
              (≈ {{ metric.impactLevel | number : '1.0-0' }} customers).
            </li>
            <li>
              <strong>{{ metric.recoveryDurationRank }}<sup>{{ metric.recoveryDurationRank | ordinalSuffix }}</sup></strong>
              in recovery duration, or the amount of time it takes to restore power for the maximum number of customers
              (≈ {{ metric.recoveryDuration | number: '1.0-0' }} minutes
              — {{ (metric.recoveryDuration / 60) |  number:  '1.0-0' }} hours).
            </li>
            <li>
              <strong>{{ metric.recoveryRateRank }}<sup>{{ metric.recoveryRateRank | ordinalSuffix }}</sup></strong>
              in the per minute recovery rate of customer outages (≈ {{ metric.recoveryRateRank | number : '1.2-2' }}
              meters/min.).
            </li>
          </ul>
        </section>
      }

    </mat-card-content>
  </mat-card>
</div>
